export default __webpack_public_path__ + "img/d1a41dca72aa552c9fcb70b9a1c1ec63.png";